import { QueryClient } from '@tanstack/react-query';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Realtime subscriptions invalidate queries when data changes, so no polling.
        staleTime: 60_000,
        refetchOnWindowFocus: true,
        retry: 1,
      },
    },
  });
}
